import { render, staticRenderFns } from "./scrapbook.vue?vue&type=template&id=c762ba32&scoped=true&"
import script from "./scrapbook.vue?vue&type=script&lang=js&"
export * from "./scrapbook.vue?vue&type=script&lang=js&"
import style0 from "./scrapbook.vue?vue&type=style&index=0&id=c762ba32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c762ba32",
  null
  
)

export default component.exports